import axios from '../utils/axios';

export default function updateSeekerPhoneStatus (adminId, data) {
    return axios.post(`/admin/${adminId}/jobseeker-admin/v2/admin-recruiter/changephonestatus`, data);
}